module.exports = __webpack_public_path__ + "img/ic_zhihu_nor-1.57d0fb21.svg";